import React from "react";
import * as S from "./index-styled";
import PT from "prop-types";
import { getClientHistory } from "@/utils/clientHistory";
import { IS_SERVER } from "@/misc/constants";
import isempty from "lodash/isEmpty";
import Basket from "./basket";
import Masters from "./masters";
import Contacts from "./contacts";
import History from "./history";
import Achieves from "./achieves";
import { useTranslation } from "react-i18next";
import { CLIENT_PROFILE_NS } from '@/i18n/ns';

const Aside = ({
  basketAmount,
  basketMaster,
  isOwner,
  history,
  masters,
  contacts,
  achieves,
  openBookingModal,
}) => {
  const { t, ready } = useTranslation(["common", CLIENT_PROFILE_NS], {
    useSuspense: false,
  });

  if (!ready) return null;
  return (
    <S.Wrap>
      <Masters t={t} isOwner={isOwner} masters={masters} />
      <Contacts t={t} isOwner={isOwner} contacts={contacts} />
      <Achieves t={t} achieves={achieves} isOwner={isOwner} />
      {isOwner && !isempty(history) && <History t={t} history={history} />}
      {isOwner && (
        <Basket
          t={t}
          amount={basketAmount}
          openBookingModal={openBookingModal}
          master={basketMaster}
        />
      )}
    </S.Wrap>
  );
};
Aside.propTypes = {
  history: PT.array,
  masters: PT.array,
  contacts: PT.array,
  achieves: PT.array,
  basketAmount: PT.number,
  basketMaster: PT.string,

  openBookingModal: PT.func.isRequired,
};
Aside.defaultProps = {
  history: IS_SERVER ? [] : getClientHistory(),
};

export default Aside;
